export const ECHO_DOMAIN = `${process.env.NEXT_PUBLIC_ECHO_DOMAIN}`;
export const CONTACT_EMAIL = `hello@foam.io`;
